import React from 'react'
import {useHistory} from "react-router"
import {useTranslation} from "react-i18next"

import {IonIcon, IonItem, IonLabel, IonNote} from "@ionic/react"
import {returnDownForwardOutline, returnDownForwardSharp} from "ionicons/icons"

import LockingSystem          from "@customTypes/LockingSystem"
import LockingSystemSyncState from "@customTypes/LockingSystemSyncState"
import {SyncCollectionItem}   from "@customTypes/SyncCollections"
import TimeDiffHuman          from "../../common/Text/TimeDiffHuman"
import NumberFormat           from "../../common/Text/NumberFormat";

interface props {
    item:                 LockingSystem
    changeSelectedItemId: any
    collectionItem:       SyncCollectionItem
    isSynchronizing:      string | null
    syncElement:          any
}

const CollectionsListItem: React.FC<props> = (
    { changeSelectedItemId, isSynchronizing, item, collectionItem, syncElement }: props
) => {

    const history = useHistory()
    const { t } = useTranslation()

    const iconSub = <IonIcon style={{ 'marginRight': '12px' }}
                             ios={returnDownForwardOutline} md={returnDownForwardSharp} />

    const goTo = (ev: any, segment: string) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (isSynchronizing === null) {
            changeSelectedItemId(item.id)
            history.push('/' + segment)
        }
    }

    const count = item.counts[collectionItem.key] || 0

    const syncSecondsAgoAttribute = collectionItem.collection
        + 'SecondsAgo' as keyof LockingSystemSyncState

    let syncedSecondsAgo: number | null = item.lockingSystemSyncState?.hasOwnProperty(syncSecondsAgoAttribute)
        ? item.lockingSystemSyncState[syncSecondsAgoAttribute] as number
        : null

    let buttonDisabled: boolean = isSynchronizing !== null ||
        (item.lockingSystemSyncState !== null && item.lockingSystemSyncState?.lockedAt !== null)

    // Show only sync buttons when the required key has count > 0
    if (! buttonDisabled) {
        if (collectionItem.key === 'keys') {
            buttonDisabled = item.counts['lockingSystemZones'] < 1
        } else if (collectionItem.key === 'people'
            || collectionItem.key === 'lockingSystemPermissions'
            || collectionItem.key === 'timeLimits'
            || collectionItem.key === 'locks') {
            buttonDisabled = item.counts['lockingSystemZones'] < 1
        } else if (collectionItem.key === 'keyPhones' || collectionItem.key === 'blocklistKeys') {
            buttonDisabled = item.counts['keys'] < 1
        } else if (collectionItem.key === 'keyLockingSystemPermissions') {
            buttonDisabled = item.counts['keys'] < 1 || item.counts['lockingSystemPermissions'] < 1
        } else if (collectionItem.key === 'keyLockingSystemZones') {
            buttonDisabled = item.counts['keys'] < 1 || item.counts['lockingSystemZones'] < 1
        } else if (collectionItem.key === 'keyTimeLimits') {
            buttonDisabled = item.counts['keys'] < 1 || item.counts['timeLimits'] < 1
        } else if (collectionItem.key === 'lockLockingSystemPermissions') {
            buttonDisabled = item.counts['locks'] < 1 || item.counts['lockingSystemPermissions'] < 1
        } else if (collectionItem.key === 'lockTimeLimits') {
            buttonDisabled = item.counts['locks'] < 1 || item.counts['timeLimits'] < 1
        }
    }

    return (
        <IonItem button detail={!buttonDisabled} disabled={buttonDisabled}
                 key={'locking-system-sync-' + item.id + '-' + collectionItem.key} lines="full"
                 onClick={(ev) => goTo(ev, collectionItem.url)}>
            {item.lockingSystemApi?.manualSync &&
            <IonNote className="ion-margin-end" style={{ 'marginTop': '8px', 'minWidth': '55px' }}>
                {item.lockingSystemApi?.id && syncElement(collectionItem)}
            </IonNote>
            }
            <IonLabel>
                    {collectionItem.sub === true && iconSub}
                    {t(collectionItem.name)}
            </IonLabel>
            <IonNote className="ion-hide-md-down ion-margin-end ion-margin-vertical ion-text-center"
                     style={{ 'minWidth': '100px' }}>
                {!buttonDisabled && (
                    item.lockingSystemSyncState?.lockedAt !== null &&
                        collectionItem.collection === item.lockingSystemSyncState?.lockedCollection
                            ? <span>syncing...</span>
                            : <TimeDiffHuman maxAge={86400} seconds={syncedSecondsAgo} useColor={true} />
                )}
            </IonNote>
            <IonNote className="ion-margin-vertical ion-text-right" style={{ 'minWidth': '50px' }}>
                {!buttonDisabled && (
                    <NumberFormat number={count} />
                )}
            </IonNote>
        </IonItem>
    )

}

export default CollectionsListItem